import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
    return (
        <>
            <Seo title="Page not found — FinCalc" description="This page does not exist." canonical="/404" />
            <section className="container-editorial py-24 max-w-2xl text-center">
                <div className="font-mono tabular text-[11px] uppercase tracking-[0.2em] text-accent">
                    404
                </div>
                <h1 className="font-serif text-6xl text-primary mt-3">Nothing here.</h1>
                <p className="mt-4 text-foreground/70">
                    The page you&apos;re after has moved, been renamed, or never existed.
                </p>
                <Link
                    to="/"
                    data-testid="notfound-home-link"
                    className="mt-8 inline-flex items-center gap-2 h-12 px-6 rounded-md bg-primary text-primary-foreground hover:bg-secondary transition-colors text-sm font-medium"
                >
                    Back to calculators
                </Link>
            </section>
        </>
    );
}
